export const productEquipmentSpecs = () => {
  const $productEquipmentSpecs = document.querySelector(
    ".product-equipment-spec"
  );
  console.log("$productEquipmentSpecs", $productEquipmentSpecs);
  if ($productEquipmentSpecs) {
    const $items = $productEquipmentSpecs.querySelectorAll(
      ".product-equipment-spec__items .product-equipment-spec__item"
    );
    const $button = $productEquipmentSpecs.querySelector(
      ".product-equipment-spec__button"
    );

    $button.addEventListener("click", (event) => {
      event.preventDefault();
      if (
        $button.classList.contains("product-equipment-spec__button--active")
      ) {
        $button.classList.remove("product-equipment-spec__button--active");
        $items.forEach(($item, index) => {
          if (index >= 3) {
            $item.classList.remove("flex");
            $item.classList.add("hidden");
          }
        });
        $button.innerText = "Show more specifications";
      } else {
        $button.classList.add("product-equipment-spec__button--active");
        $items.forEach(($item, index) => {
          if (index >= 3) {
            $item.classList.remove("hidden");
            $item.classList.add("flex");
          }
        });
        $button.innerText = "Show less specifications";
      }
    });
  }
};

export default productEquipmentSpecs;
